<template>
  <div>
    <!-- <v-divider class="my-2"></v-divider> -->
    <div class="headerBar mb-2 d-flex flex-row flex-wrap py-1 px-2">
      <div>
        <vs-scenario-settings
          :rxs="rxs"
          @correctionRx="correctionRx = $event"
          @correctionType="correctionType = $event"
          :lookingAtText="lookingAtText"
          @correctionText="correctionText = $event"
        >
        </vs-scenario-settings>
      </div>
      <v-spacer></v-spacer>
      <slot></slot>
    </div>

    <div>
      <div v-for="eye in eyes" :key="eye" class="" style="position: relative">
        <div class="overline mt-3" v-if="eyes.length > 1">
          {{ eye | eyeText }} Eye
        </div>
        <image-and-eye-row
          v-for="key in imageKeys"
          :key="key"
          :eye="eye"
          :rxs="rxsAfterCorrection"
          :lookingAt="key"
          :accomAbility="accomAbility"
          :yokedAccommodation="yokedAccommodation"
          :correctionType="correctionType"
          :correctionText="correctionText"
          style="position: relative"
        >
        </image-and-eye-row>
      </div>
    </div>
    <!-- </v-expand-transition> -->
  </div>
</template>

<script>
import ImageAndEyeRow from "./ImageAndEyeRow.vue";
import VsScenarioSettings from "./VsScenarioSettings.vue";
import RxMethods from "@/assets/js/cls/RxMethods";
import VsDefinitions from "./VsDefinitions";

export default {
  name: "VsScenarioRow",
  props: {
    rxs: null,
    yokedAccommodation: null,
    accomAbility: {
      type: Number,
      default: 4,
    },
    eyes: {
      type: Array,
      default: function () {
        return ["od", "os"];
      },
    },
    metric: null,
    focusItems: null,
  },
  components: {
    ImageAndEyeRow,
    VsScenarioSettings,
    // FarPointRow: () => import("./FarPointRow"),
  },
  mixins: [RxMethods],
  data: function () {
    return {
      imgPath: "https://www.eyedock.com/images/visionSimulator/",
      correctionRx: null,
      // accomAbility: 4,
      correctionType: null,
      lookingAt: "far",
      correctionText: null,
      // expandScenarioTarget: null,
    };
  },
  methods: {},
  computed: {
    isPhone: function () {
      return this.$vuetify.breakpoint.xs;
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },
    lookingAtObjectIndex: function () {
      return this.lookingAtArr.indexOf(this.lookingAt);
    },
    lookingAtArr: function () {
      return Object.keys(this.lookingAtData);
    },
    rxsAfterCorrection: function () {
      let rtn = { od: this.rxs?.od, os: this.rxs?.os };
      ["od", "os"].forEach((eye) => {
        if (this.correctionRx?.[eye] && this.rxs?.[eye]) {
          rtn[eye] = this.subtractRx(this.rxs[eye], this.correctionRx[eye]);
        }
      });
      return rtn;
    },
    lookingAtData: function () {
      return VsDefinitions.lookingAtData;
    },
    lookingAtText: function () {
      return this.lookingAtData[this.lookingAt][
        this.metric ? "distance_metric" : "distance"
      ];
    },
    // allKeys: function () {
    //   return Object.keys(this.focusItems);
    // },
    imageKeys: function () {
      return Object.keys(this.focusItems);
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style scoped>
.headerBar {
  background-color: #f5f5f5;
  border-radius: 5px;
  padding: 3px 10px;
  border: 1px solid #c3c3c3;
}
</style>
